import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { TourStep } from '@/components/common/TourOverlay.vue'

/**
 * Drives TourOverlay.vue, which is mounted once, globally, in App.vue. Living in a
 * store (rather than page-local state) keeps the overlay alive across whatever the
 * steps click (tabs, hash changes) — only the page underneath it changes.
 *
 * Only the per-page "Vodič kroz ovu stranicu" tours behind the ? button in the
 * header run through here (see composables/pageTours.ts).
 */
export const useTourStore = defineStore('tour', () => {
    const active = ref(false)
    const steps = ref<TourStep[]>([])

    function start(newSteps: TourStep[]) {
        steps.value = newSteps
        active.value = true
    }

    function stop() {
        active.value = false
        steps.value = []
    }

    return { active, steps, start, stop }
})
